import React from 'react'
import { MainBlock } from '@blocks/BlockMain/model'
import { EaseSavingsElement } from '@shared/components/sections/ease-savings/data'

import { PagesPath, pagesTitles } from './pages-titles'

export const mainBlock: MainBlock = {
	title: pagesTitles[PagesPath.loanRefinance].mainBlockTitle,
	textItems: [
		'Снижаем процентную ставку по кредиту от 4,9% годовых',
		'Значительно уменьшим платёж по кредитам',
		'Сумма от 1 млн рублей на любые цели',
	],
	buttonText: 'Оставить заявку',
	faceImageName: {
		mobile: 'KV-loans-business-mob.png',
		default: 'keyvisual-loans-business.png',
	},
	imageAlt: 'Владимир Холодилов, руководитель отдела по работе с клиентами',
}

export const easeSavingsData: EaseSavingsElement[] = [
	{
		number: 1,
		title: <>Рефинансируйте любые кредиты от&nbsp;1&nbsp;млн рублей.</>,
	},
	{
		number: 2,
		title: 'Закройте невыгодные займы.',
	},
	{
		number: 3,
		title: 'Получите дополнительную сумму на любые цели.',
	},
]
